import { useEffect } from "react";

function setMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

export default function Seo({ title, description, image, url, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:image", image);
    setMeta("property", "og:url", url || window.location.href);
    setMeta("name", "twitter:card", "summary_large_image");
    let s;
    if (jsonLd) {
      s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo", "1");
      s.text = JSON.stringify(jsonLd);
      document.head.appendChild(s);
    }
    return () => { if (s) s.remove(); };
  }, [title, description, image, url, jsonLd]);
  return null;
}
